/*
  <rk-announcement> – blendet bis zu 3 Nachrichten nacheinander über.
  Pause bei Hover/Fokus und bei verborgenem Tab. Bei reduzierter Bewegung
  wird ohne Überblendung gewechselt (CSS).
*/
if (!customElements.get('rk-announcement')) {
  class RkAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.rk-announcement__item'));
      if (this.items.length < 2) return;

      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.paused = false;

      this.pause = () => (this.paused = true);
      this.resume = () => (this.paused = false);
      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.resume);

      this.timer = window.setInterval(() => {
        if (this.paused || document.hidden) return;
        this.show((this.index + 1) % this.items.length);
      }, this.interval);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    show(next) {
      this.items.forEach((item, i) => {
        const active = i === next;
        item.classList.toggle('is-active', active);
        if (active) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
        const link = item.querySelector('a');
        if (link) link.tabIndex = active ? 0 : -1;
      });
      this.index = next;
    }
  }

  customElements.define('rk-announcement', RkAnnouncement);
}
